/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { InseeHistorique, ModalInsee } from '@/components/Insee';

interface InseeHistoriqueModalProps {
  open: boolean;
  onClose: () => void;
  /** Appelé après une dévalidation, pour rafraîchir le compteur du tableau de bord */
  onChange?: () => void;
}

/** Historique des transferts INSEE, en modale depuis le tableau de bord */
const InseeHistoriqueModal = ({
  open,
  onClose,
  onChange,
}: InseeHistoriqueModalProps) => (
  <InseeHistorique actif={open} onChange={onChange}>
    {(vue) => (
      <ModalInsee
        vue={vue}
        open={open}
        onClose={onClose}
        data-testid="insee-historique-modal"
      />
    )}
  </InseeHistorique>
);

export default InseeHistoriqueModal;
